var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3ExpandArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.162 11.162V7.144l-4.92 4.921-.904-.903 4.92-4.921h-4.017L12 5h7.403v7.403l-1.24-1.24zM6.241 13.241v4.018l4.921-4.921.903.903-4.92 4.921h4.017l1.241 1.241H5V12l1.241 1.241z",
    fill: "#A4AAAE"
  })));
}
export default __webpack_public_path__ + "static/media/E3_expand_arrows.5b7aa6c8.svg";
export { SvgE3ExpandArrows as ReactComponent };